export const InfoIcon = (): JSX.Element => {
  return (
    <svg width="24" height="20" fill="none">
      <g clipPath="url(#a)" fill="#302C41">
        <path d="M10 19.56C4.73 19.56.44 15.27.44 10 .44 4.73 4.73.44 10 .44c5.27 0 9.56 4.29 9.56 9.56 0 5.27-4.29 9.56-9.56 9.56Zm0-17.5c-4.38 0-7.94 3.56-7.94 7.94 0 4.38 3.56 7.94 7.94 7.94 4.38 0 7.94-3.56 7.94-7.94 0-4.38-3.56-7.94-7.94-7.94Z" />
        <path d="M10 13.05c-.45 0-.81-.36-.81-.81V4.83c0-.45.36-.81.81-.81.45 0 .81.36.81.81v7.41c0 .45-.36.81-.81.81ZM10 15.17a.42.42 0 1 0 0-.84.42.42 0 0 0 0 .84Z" />
        <path d="M10 15.98a1.23 1.23 0 1 1 0-2.46 1.23 1.23 0 1 1 0 2.46Zm0-1.63a.39.39 0 0 0-.39.39c0 .21.18.39.39.39.21 0 .39-.18.39-.39 0-.21-.18-.39-.39-.39Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}
